import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForgotPasswordModule } from './forgot-password/forgot-password.module';
import { ResetPasswordModule } from './reset-password/reset-password.module';
import { InviteModule } from './invite/invite.module';
import { AuthModule } from './auth/auth.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AuthModule,
    ForgotPasswordModule,
    ResetPasswordModule,
    InviteModule,
  ],
})
export class PublicPagesModule {}
